import { PropsWithChildren } from "react";

import { classNames } from "@helpers/css";

type Props = {
  ariaLabel?: string;
  maxWidth?: "lg" | "7xl" | "full";
  padding?: "default" | "settings";
};

const MainContainer: React.FC<PropsWithChildren<Props>> = ({
  children,
  ariaLabel,
  maxWidth = "7xl",
  padding = "default",
}) => (
  <main
    className={classNames(
      "flex-1 relative z-0 overflow-y-auto focus:outline-none",
      padding === "settings" && "bg-white",
    )}
    aria-label={ariaLabel}
  >
    <div
      className={classNames(
        "mx-auto",
        padding === "default" && "py-6 sm:px-6 lg:px-8",
        padding === "settings" && "px-16 py-12",
        maxWidth === "lg" && "max-w-screen-lg",
        maxWidth === "7xl" && "max-w-7xl",
        maxWidth === "full" && "",
      )}
    >
      {children}
    </div>
  </main>
);

export default MainContainer;
